import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { Toaster } from "@/components/ui/sonner";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import HomePage from "@/pages/HomePage";
import VTCRentalPage from "@/pages/VTCRentalPage";
import HowItWorksPage from "@/pages/HowItWorksPage";
import ContactPage from "@/pages/ContactPage";
import CGVPage from "@/pages/CGVPage";
import PrivacyPage from "@/pages/PrivacyPage";

function App() {
  return (
    <HelmetProvider>
      <div className="App min-h-screen bg-[#050505]">
        <BrowserRouter>
          <Navbar />
          <main>
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/location-vtc" element={<VTCRentalPage />} />
              <Route path="/comment-ca-marche" element={<HowItWorksPage />} />
              <Route path="/contact" element={<ContactPage />} />
              <Route path="/cgv" element={<CGVPage />} />
              <Route path="/confidentialite" element={<PrivacyPage />} />
            </Routes>
          </main>
          <Footer />
          <Toaster position="top-right" richColors />
        </BrowserRouter>
      </div>
    </HelmetProvider>
  );
}

export default App;
